const KEYS = {
  email: 'rememberedEmail',
  password: 'rememberedPassword',
  flag: 'rememberMe',
};

export const isRememberMeEnabled = () => localStorage.getItem(KEYS.flag) === 'true';

export const loadRememberedLogin = () => {
  if (!isRememberMeEnabled()) {
    return { email: '', password: '', rememberMe: false };
  }

  return {
    email: localStorage.getItem(KEYS.email) || '',
    password: localStorage.getItem(KEYS.password) || '',
    rememberMe: true,
  };
};

export const saveRememberedLogin = ({ email, password }) => {
  localStorage.setItem(KEYS.flag, 'true');
  localStorage.setItem(KEYS.email, email);
  localStorage.setItem(KEYS.password, password);
};

export const clearRememberedLogin = () => {
  localStorage.removeItem(KEYS.flag);
  localStorage.removeItem(KEYS.email);
  localStorage.removeItem(KEYS.password);
};

export const setRememberMePreference = (enabled) => {
  if (enabled) {
    localStorage.setItem(KEYS.flag, 'true');
  } else {
    clearRememberedLogin();
  }
};
